/* node_modules */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import LoginForm from '~/components/LoginForm';

/**
 * @type {React.FC}
 */
const LoginScreen = () => {
  const location = useLocation();
  const { isSignedIn } = useSelector(state => state.currentUser);
  const referral = useMemo(() => {
    const url = new URLSearchParams(location.search);

    return url.get('referral');
  }, [location]);

  if (isSignedIn) return <Navigate to={referral || '/'} />;

  return (
    <LoginForm />
  );
};

export default LoginScreen;
